import { WeightOptionEnum } from '@shared/api/types';
import { SelectOption } from '@shared/components/form/select-form-field';

export const weightOptions: SelectOption[] = [
  {
    label: '% of purchased goods',
    value: WeightOptionEnum['purchased_goods'],
  },
  {
    label: '% of purchased food',
    value: WeightOptionEnum['food'],
  },
  {
    label: '% of purchased packaging',
    value: WeightOptionEnum['packaging'],
  },

  {
    label: 'Total weight (tonnes)',
    value: WeightOptionEnum['total_weight'],
  },
];
